import './Label.css'
import { useRef, useState } from 'react'
import { Html } from '@react-three/drei'

export default function Label(props)
{
    const [occluded, setOccluded] = useState(false)
    return (
        <Html
            {...props}
            center
            onOcclude={setOccluded}
            occlude={[props.occlude]}
            distanceFactor={10}
            wrapperClass="label"

            style={{
                transition: 'all 0.5s',
                opacity: occluded ? 0 : 1,
                transform: `scale(${occluded ? 0.5 : 1}) translate(-50%, -50%)`,
            }}
        >
            <div
                className={'dot ' + (props.visible ? 'in ' : '')}
                onClick={() =>
                {
                    props.setCurrentArticleIndex(props.articleIndex)
                    props.setArticleOpen(true)
                }}
            >
                {props.debug ? <p style={{ color: 'white' }}>{props.shardNumber}</p> : ""}
            </div>
        </Html>
    )
}